import { FC } from 'react'
import Layout from 'components/Layout/Layout'
import WholesalerTemplate from 'components/Templates/WholesalerTemplate'

const Wholesaler: FC = () => {
  return (
    <Layout title={'問屋マスター一覧'} page="Wholesaler">
      <WholesalerTemplate />
    </Layout>
  )
}

export default Wholesaler
